import GLightbox from 'glightbox'

let lightbox

export default {
  init() {
    document.addEventListener('lightbox.toggle', (e) => {
      if (e.detail) {
        lightbox = GLightbox(e.detail)
        lightbox.open()
      }
    })
  }
}
